// hooks
import { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import useHttp from "hooks/use-http";

// routes
import { useNavigate } from "react-router-dom";

// material styles
import { Grid, TextField, Button } from "@mui/material";

// material icons
import CheckIcon from "@mui/icons-material/Check";

// react icons
import { ImUpload } from "react-icons/im";

// request methods

// components
import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import ProgressBarCM from "components/shared/ProgressBar";
import BackButton from "components/shared/BackButton";

// helper
import Toast from "helper/toast";
import { convertNum } from "helper/convert-num";

// form validate
import { excellSchema, teacherSchema, validateFile } from "validations";

// styled component
import {
  StyledStack,
  StyledTitle,
  StyledGridBox,
  StyledContainerBox,
  StyledUploadBox,
  StyledMenuItem,
  StyledDateBox,
  StyledChoiceFileText,
  ButtonContainer,
} from "./addScore.style";
import { toast } from "react-toastify";
import ReactHookFormSelect from "components/shared/ReactHookFormSelect";
import DatePickerCM from "components/shared/DatePicker";
import { useCallback } from "react";
import {
  addScoresExcellFileRequest,
  getAllClassRequest,
  getTeacherClassesRequest,
} from "api/requests";
import { setCacheNameDetails } from "workbox-core";

export default function AddScoreExcellFile() {
  const navigate = useNavigate();

  // upload files state
  const [file, setFile] = useState("");

  const [date, setDate] = useState("");
  const onDateHandler = (value) =>
    setDate(
      value
        .format("YYYY-MM-DD")
        .split("/")
        .map((item) => convertNum(item))
        .join("-")
    );

  const {
    request,
    loading,
    setLoading,
    isUploading,
    uploadProgress,
    setUploadProgress,
  } = useHttp(false);

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(excellSchema),
  });

  const [classData, setClassData] = useState({ data: [], count: 0 });
  const [selectedClass, setSelectedClass] = useState();

  const onSubmit = async (data) => {
    if (!file) {
      return Toast({ type: "custom", title: "فایل را وارد کنید" });
    }
    const file_format = ["xlsx", "xlsm", "xlsb", "xls", "csv"];
    const fileTypeValidate = validateFile(
      data.excell_file[0],
      "اکسل",
      10_000_000,
      file_format
    );

    const res =
      file && !fileTypeValidate
        ? ""
        : await request({
            url: () =>
              addScoresExcellFileRequest(
                {
                  ...data,
                  excel_file: data.excell_file[0],
                  date: date,
                  isFile: true,
                },
                (progress) => setUploadProgress(progress)
              ),
            isFile: true,
          });
    if (res) {
      Toast({ type: "success", title: "افزودن فایل" });
      navigate("/teacher_scores_excell-file");
    }
  };
  const getClassData = useCallback(async () => {
    const classRes = await request({
      url: getTeacherClassesRequest,
    });
    if (classRes) {
      setClassData({ data: classRes.data, count: classRes.count });
    }
  }, []);

  useEffect(() => {
    getClassData();
  }, []);

  return (
    <DrawerCM title="افزودن نمرات" $styledHeader>
      {file && isUploading ? (
        <ProgressBarCM value={uploadProgress} />
      ) : loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container>
            <Grid item mt={3} xs={12}>
              <BackButton />
            </Grid>
            <StyledStack>
              <Grid>
                <StyledTitle>افزودن نمرات</StyledTitle>
                <Grid container>
                  <Grid item md={6} xs={12} p={1.5}>
                    <TextField
                      label="عنوان"
                      variant="outlined"
                      fullWidth
                      id="title"
                      {...register("title")}
                      error={Boolean(errors.title)}
                      helperText={errors.title?.message}
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                    p={1.5}
                    sx={{ position: "relative", zIndex: 1 }}
                  >
                    <StyledDateBox>
                      <DatePickerCM
                        bottom
                        onChange={onDateHandler}
                        render={(value, openCalendar) => {
                          return (
                            <TextField
                              label="تاریخ"
                              variant="outlined"
                              fullWidth
                              id="date"
                              {...register("date")}
                              error={Boolean(errors.date)}
                              helperText={errors.date?.message}
                              value={date ? date.split("-").join("/") : ""}
                              onClick={openCalendar}
                            />
                          );
                        }}
                      />
                    </StyledDateBox>
                  </Grid>
                  <Grid item md={6} xs={12} p={1.5}>
                    <ReactHookFormSelect
                      label="نام کلاس"
                      control={control}
                      title="نام کلاس"
                      id="class_id"
                      {...register("class_id")}
                      error={Boolean(errors.class_id)}
                      helperText={errors.class_id?.message}
                      value={selectedClass ?? ""}
                      onChange={(value) => setSelectedClass(value)}
                    >
                      {classData?.data?.map((item, index) => (
                        <StyledMenuItem key={index} value={item.id}>
                          {item.title}
                        </StyledMenuItem>
                      ))}
                    </ReactHookFormSelect>
                  </Grid>
                  <StyledGridBox item md={6} xs={12} p={1.5} file={file}>
                    <StyledContainerBox>
                      <StyledUploadBox>
                        <StyledChoiceFileText>
                          {file ? file : "آپلود فایل اکسل "}
                        </StyledChoiceFileText>
                        <ImUpload />
                      </StyledUploadBox>
                      <TextField
                        variant="outlined"
                        type="file"
                        fullWidth
                        {...register("excell_file")}
                        onChange={(e) => setFile(e.target.files[0].name)}
                      />
                    </StyledContainerBox>
                  </StyledGridBox>
                  <Grid item xs={12} p={1.5}>
                    <TextField
                      label="توضیحات"
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={5}
                      id="description"
                      {...register("description")}
                      error={Boolean(errors.description)}
                      helperText={errors.description?.message}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <ButtonContainer>
                <Button
                  color="success"
                  startIcon={<CheckIcon />}
                  variant="contained"
                  sx={{ mt: 1, mr: 1 }}
                  onClick={handleSubmit(onSubmit)}
                >
                  ثبت
                </Button>
              </ButtonContainer>
            </StyledStack>
          </Grid>
        </Fragment>
      )}
    </DrawerCM>
  );
}
